import { createAsyncThunk, createEntityAdapter, createSlice, EntityState } from '@reduxjs/toolkit';

import { IGetTaskDetailsParams, ISubmitTaskParams } from 'api/digifi/los/TaskDetailsApi';
import { IFindTaskParams, ITask } from 'api/digifi/los/TasksApi';
import { RootState } from 'store';
import { taskDetailsApi, tasksApi } from 'store/api';

enum TasksActionType {
  FindTasks = 'tasks/findTasks',
  SubmitTask = 'tasks/submitTask',
  GetTaskDetails = 'tasks/getTaskDetails',
}

const tasksAdapter = createEntityAdapter<ITask>();

export interface ITasksState extends EntityState<ITask> {}

const initialState: ITasksState = tasksAdapter.getInitialState();

export const findApplicationTasks = createAsyncThunk(
  TasksActionType.FindTasks,
  async (params: IFindTaskParams) => {
    return tasksApi.find(params);
  },
);

export const getTaskDetails = createAsyncThunk(
  TasksActionType.GetTaskDetails,
  async (params: IGetTaskDetailsParams) => {
    return taskDetailsApi.getTaskDetails(params);
  },
);

export const submitTask = createAsyncThunk(
  TasksActionType.SubmitTask,
  async (params: ISubmitTaskParams) => {
    return taskDetailsApi.submit(params);
  },
);

const tasksSlice = createSlice({
  name: 'tasksSlice',
  initialState,
  reducers: {
  },
  extraReducers: builder => {
    builder
      .addCase(findApplicationTasks.fulfilled, (state, { payload }) => {
        tasksAdapter.setAll(state, payload);
      })
      .addCase(submitTask.fulfilled, (state, { payload }) => {
        tasksAdapter.upsertOne(state, payload);
      })
      .addCase(getTaskDetails.fulfilled, (state, { payload }) => {
        tasksAdapter.upsertOne(state, payload.task);
      });
  },
});

export const { selectEntities: selectTaskEntities } = tasksAdapter.getSelectors((state: RootState) => state.tasks);

export default tasksSlice.reducer;
